export default {
  unmask: string => {
    if (!string) return ''
    return string.replace(/\D/g, '')
  }
}
